/**
 * Sync Watch — synchronised Netflix playback for watch parties
 *
 * Declares a single web-accessible-resource entry with one file,
 * `js/players/netflix/netflix.js`, matched only to `https://www.netflix.com/*`
 * and with no `use_dynamic_url`. The path is static, so it is fetchable at a
 * fixed URL — but only from Netflix, since the `matches` covers no other origin.
 *
 * So this extension is detectable, yet only by netflix.com. From any other page
 * the resource is unreachable and a negative result proves nothing.
 *
 * Manifest verified against version 1.1.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ggiafipgeeaaahnjamgpjcgkdpanhddg';

export const syncWatch: ExtensionDefinition = {
  id: ID,
  name: 'Sync Watch',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://www.netflix.com',
  notes:
    'One static WAR scoped to www.netflix.com. Only that origin can reach it, ' +
    'so detection is conclusive there and inconclusive everywhere else.',
  signals: [
    {
      id: 'war-netflix-player-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/players/netflix/netflix.js — the Netflix player integration script, ' +
        'static but exposed only to www.netflix.com.',
      weight: 1,
      run: () => probeFetch(ID, 'js/players/netflix/netflix.js'),
    },
  ],
};
